class KeyfigureTabs {
  constructor() {
    this.containers = Array.prototype.slice.call(
      document.querySelectorAll(".lc-keyfigure-tabs")
    );

    if (this.containers.length) {
      this.containers.forEach((container) => this.init(container));
    }
  }

  init(container) {
    const nav = container.querySelector("[data-keyfigure-tabs-nav]");
    const track = container.querySelector(".lc-keyfigure-tabs__track");
    const panels = Array.prototype.slice.call(
      container.querySelectorAll("[data-keyfigure-panel]")
    );

    if (!nav || !track || !panels.length) {
      return;
    }

    const tabs = panels.map((panel, index) => {
      const labelEl = panel.querySelector(".lc-keyfigure-tabs__panel-label");
      const label = labelEl ? labelEl.textContent.trim() : `Tab ${index + 1}`;
      const tabId = `keyfigure-tab-${index}-${Math.random().toString(36).slice(2, 7)}`;
      const panelId = `keyfigure-panel-${index}-${Math.random().toString(36).slice(2, 7)}`;

      panel.id = panelId;
      panel.setAttribute("aria-labelledby", tabId);
      panel.setAttribute("aria-hidden", index === 0 ? "false" : "true");

      const button = document.createElement("button");
      button.type = "button";
      button.className = "lc-keyfigure-tabs__tab";
      button.id = tabId;
      button.setAttribute("role", "tab");
      button.setAttribute("aria-controls", panelId);
      button.setAttribute("aria-selected", index === 0 ? "true" : "false");
      button.tabIndex = index === 0 ? 0 : -1;
      button.textContent = label;

      if (index === 0) {
        button.classList.add("is-active");
        panel.classList.add("is-active");
      }

      button.addEventListener("click", () => {
        this.activate(container, track, panels, tabs, index);
      });

      button.addEventListener("keydown", (event) => {
        this.onKeydown(event, container, track, panels, tabs, index);
      });

      nav.appendChild(button);
      return button;
    });

    container.classList.add("is-ready");
    this.activate(container, track, panels, tabs, 0, false);
  }

  activate(container, track, panels, tabs, index, animate = true) {
    if (!animate) {
      track.style.transition = "none";
    } else {
      track.style.transition = "";
    }

    track.style.transform = `translateX(-${index * 100}%)`;

    panels.forEach((panel, panelIndex) => {
      const isActive = panelIndex === index;
      panel.classList.toggle("is-active", isActive);
      panel.setAttribute("aria-hidden", isActive ? "false" : "true");
    });

    tabs.forEach((tab, tabIndex) => {
      const isActive = tabIndex === index;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
      tab.tabIndex = isActive ? 0 : -1;
    });

    if (!animate) {
      void track.offsetWidth;
      track.style.transition = "";
    }

    container.setAttribute("data-active-index", String(index));
  }

  onKeydown(event, container, track, panels, tabs, index) {
    let nextIndex = null;

    if (event.key === "ArrowRight" || event.key === "ArrowDown") {
      nextIndex = (index + 1) % tabs.length;
    } else if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
      nextIndex = (index - 1 + tabs.length) % tabs.length;
    } else if (event.key === "Home") {
      nextIndex = 0;
    } else if (event.key === "End") {
      nextIndex = tabs.length - 1;
    }

    if (nextIndex === null) {
      return;
    }

    event.preventDefault();
    this.activate(container, track, panels, tabs, nextIndex);
    tabs[nextIndex].focus();
  }
}

export default KeyfigureTabs;
